
import { api_host,api_auth} from '../../common/globals/constants';

export const getDetalleDisponibilidadConsolidada = (user, objetivo_id, period, node, token) => 
fetch(api_host+`/reporte/online/indicadores/getDetalleDisponibilidadConsolidada/?user=${user}&key=${api_auth}&objetivoId=${objetivo_id}&horarioId=0&t=${period}&token=${token}&nodoId=${node}`)

